import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SessionService, TokenData } from '../../services/ssession.service';
import { CommonModule } from '@angular/common';
import { HideMenuDirective } from './hide-menu.directive';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    CommonModule,
    HideMenuDirective
  ],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  public name = environment.name;

  public desc = environment.description;

  public production = environment.production;

  public showUELogo = environment.topRightUELogoEnabled;

  public authed: boolean = SessionService.Authed();

  public tokenData: TokenData | null = SessionService.GetTokenData();

  public dataCompleted: boolean = SessionService.IsCompletedUserData();

  constructor(
    private router: Router
  ) {
  }

  public get appLogoPath(): string {
    return `url(${environment.appLogoTopUrl})`;
  }

  public toggleGovMenuNav(): void {
    if (document.body.classList.contains('js-show-gov-menu')) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  public hideMenu(): void {
    setTimeout(() => {
      document.body.classList.remove('js-show-gov-menu');
    });
  }

  public showMenu(): void {
    setTimeout(() => {
      document.body.classList.add('js-show-gov-menu');
    });
  }

  public onLoginSSO(): void {
    SessionService.SetGoBackUrl(this.router.url);
  }

  public ngOnInit(): void {
  }
}
